/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/anchor-has-content */
import fs from 'fs';
import { join } from 'path';

import React from 'react';

import ReactMarkdown from 'react-markdown';

import { CoinsList } from '@appComponents/bb-coinlistView';

import { SEO, FaqItem } from '@components';

const titleText = 'FAQ on Trading Digital Currency in India';
const description =
	'Check out the frequently asked question related to trading digital currency in India. Is cryptocurrency legal in India?';
const url = 'https://bitbns.com/faq/';

interface QnA {
	q: string;
	a: string;
}

interface Props {
	faqHome: QnA[];
	account: QnA[];
	kyc: QnA[];
	transinfo: QnA[];
	tradeinfo: QnA[];
	security: QnA[];
	other: QnA[];
}

const FaqData = ({
	faqHome = [],
	account = [],
	kyc = [],
	transinfo = [],
	tradeinfo = [],
	security = [],
	other = [],
}: Props) => (
	<div className="bg-white">
		<SEO title={titleText} description={description} url={url} />

		<div className="bg-primary text-white py-8">
			<div className="container">
				<h1 className=" font-bold text-center my-0 text-3xl">
					FAQ - Bitbns
				</h1>
			</div>
		</div>
		<div className="bg-white px-4">
			<div className="mx-auto py-16 max-w-6xl">
				<h3 className="text-center text-2xl font-bold my-6">
					Information of Cryptocurrencies 101
				</h3>
				<div className="my-12">
					<ol className="pl-8">
						{faqHome.map(({ q, a }) => (
							<FaqItem
								key={q}
								q={<ReactMarkdown>{q}</ReactMarkdown>}
								a={
									<ReactMarkdown
										components={{
											a: props => (
												<a
													{...props}
													target="_blank"
													rel="noreferrer noopener"
													className="font-bold c-links"
												/>
											),
											p: props => (
												<p
													{...props}
													className="mb-4"
												/>
											),
										}}
									>
										{a}
									</ReactMarkdown>
								}
							/>
						))}
					</ol>
				</div>

				<h3 className="text-center text-2xl font-bold my-6">Account</h3>
				<div className="my-12">
					<ol className="pl-8">
						{account.map(({ q, a }) => (
							<FaqItem
								key={q}
								q={<ReactMarkdown>{q}</ReactMarkdown>}
								a={
									<ReactMarkdown
										components={{
											a: props => (
												<a
													{...props}
													target="_blank"
													rel="noreferrer noopener"
													className="font-bold c-links"
												/>
											),
											p: props => (
												<p
													{...props}
													className="mb-4"
												/>
											),
										}}
									>
										{a}
									</ReactMarkdown>
								}
							/>
						))}
					</ol>
				</div>

				<h3 className="text-center text-2xl font-bold my-6">
					Registration &amp; KYC Process
				</h3>
				<div className="my-12">
					<ol className="pl-8">
						{kyc.map(({ q, a }) => (
							<FaqItem
								key={q}
								q={<ReactMarkdown>{q}</ReactMarkdown>}
								a={
									<ReactMarkdown
										components={{
											a: props => (
												<a
													{...props}
													target="_blank"
													rel="noreferrer noopener"
													className="font-bold c-links"
												/>
											),
											p: props => (
												<p
													{...props}
													className="mb-4"
												/>
											),
										}}
									>
										{a}
									</ReactMarkdown>
								}
							/>
						))}
					</ol>
				</div>

				<h3 className="text-center text-2xl font-bold my-6">
					Deposit &amp; Withdrawal Info
				</h3>
				<div className="my-12">
					<ol className="pl-8">
						{transinfo.map(({ q, a }) => (
							<FaqItem
								key={q}
								q={<ReactMarkdown>{q}</ReactMarkdown>}
								a={
									<ReactMarkdown
										components={{
											a: props => (
												<a
													{...props}
													target="_blank"
													rel="noreferrer noopener"
													className="font-bold c-links"
												/>
											),
											p: props => (
												<p
													{...props}
													className="mb-4"
												/>
											),
										}}
									>
										{a}
									</ReactMarkdown>
								}
							/>
						))}
					</ol>
				</div>

				<h3 className="text-center text-2xl font-bold my-6">
					Trading Info
				</h3>
				<div className="my-12">
					<ol className="pl-8">
						{tradeinfo.map(({ q, a }) => (
							<FaqItem
								key={q}
								q={<ReactMarkdown>{q}</ReactMarkdown>}
								a={
									<ReactMarkdown
										components={{
											a: props => (
												<a
													{...props}
													target="_blank"
													rel="noreferrer noopener"
													className="font-bold c-links"
												/>
											),
											p: props => (
												<p
													{...props}
													className="mb-4"
												/>
											),
										}}
									>
										{a}
									</ReactMarkdown>
								}
							/>
						))}
					</ol>
				</div>

				<h3 className="text-center text-2xl font-bold my-6">
					Security
				</h3>
				<div className="my-12">
					<ol className="pl-8">
						{security.map(({ q, a }) => (
							<FaqItem
								key={q}
								q={<ReactMarkdown>{q}</ReactMarkdown>}
								a={
									<ReactMarkdown
										components={{
											a: props => (
												<a
													{...props}
													target="_blank"
													rel="noreferrer noopener"
													className="font-bold c-links"
												/>
											),
											p: props => (
												<p
													{...props}
													className="mb-4"
												/>
											),
										}}
									>
										{a}
									</ReactMarkdown>
								}
							/>
						))}
					</ol>
				</div>
				<h3 className="text-center text-2xl font-bold my-6">Other</h3>
				<div className="my-12">
					<ol className="pl-8">
						{other.map(({ q, a }) => (
							<FaqItem
								key={q}
								q={<ReactMarkdown>{q}</ReactMarkdown>}
								a={
									<ReactMarkdown
										components={{
											a: props => (
												<a
													{...props}
													target="_blank"
													rel="noreferrer noopener"
													className="font-bold c-links"
												/>
											),
											p: props => (
												<p
													{...props}
													className="mb-4"
												/>
											),
										}}
									>
										{a}
									</ReactMarkdown>
								}
							/>
						))}
					</ol>
				</div>
			</div>
		</div>
		<CoinsList buy price singleLine />
	</div>
);

export default FaqData;

export function getStaticProps() {
	// const content = await markdownToHtml((post.content as string) || '');
	const faqContents = fs.readFileSync(
		`${join(process.cwd(), 'data')}/faq/faq.json`,
		'utf8'
	);

	const faqJson = JSON.parse(faqContents) as Props;

	return {
		props: {
			...faqJson,
		},
	};
}
